<script>
export default {
  props: {
    items: Array,
  },
};
</script>
<template>
  <div v-if="items" class="mag-history-table">
    <div class="mag-history-table__head">
      <div class="mag-history-table__time">Время</div>
      <div class="mag-history-table__action">Событие</div>
      <div class="mag-history-table__discription">Описание</div>
      <div class="mag-history-table__user">Пользователь</div>
    </div>
    <div class="mag-history-table__body">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="mag-history-table__row"
      >
        <div class="mag-history-table__time">{{item.Created.Serialized}}</div>
        <div class="mag-history-table__action">{{item.Action}}</div>
        <div class="mag-history-table__discription">{{item.Description}}</div>
        <div class="mag-history-table__user">{{item.UserName}}</div>
      </div>
    </div>
  </div>
</template>
